import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTryitonlineComponent } from './simple-icons-tryitonline.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTryitonlineComponent ],
    exports:      [ SimpleIconsTryitonlineComponent ],
    bootstrap:    []
})
export class SimpleIconsTryitonlineModule {}
